<template>
    <div class="h-100">
        <ul>
            <template v-for="user in users">
                <User :user="user" :key="user.id" />
            </template>
        </ul>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import User from "./User";

export default {
    name: "users-list",
    components: {
        User,
    },
    computed: {
        ...mapGetters("conference", ["getUsers"]),
        users() {
            return this.getUsers;
        },
    },
    methods: {
        ...mapActions("chat", ["toggleUsersList"]),
        closeUsers() {
            this.toggleUsersList();
        },
    },
};
</script>
